<template>
  <router-link
    class="product-category-link"
    :to="{
      name: route,
      params: { productCategoryId: productCategory.id },
    }"
  >
    <div class="product-category-card card">
      <div class="card-body">
        <div class="card-title card-name">{{ productCategory.name }}</div>
        <br />
        <!-- <div class="trashIcon" @click="deleteProductCategory">
          <font-awesome-icon class="icon" icon="trash" />
        </div> -->
      </div>
    </div>
  </router-link>
</template>

<script>
export default {
  data() {
    return {
      id: this.productCategory.id,
    }
  },
  methods: {
    deleteProductCategory(event) {
      event.preventDefault()
      if (confirm('are you sure?')) {
        if (this.experience) {
          this.$store
            .dispatch('experience/removeExperienceCategory', this.id)
            .then(() => {
              this.$store.dispatch('experience/fetchExperienceCategories')
            })
            .catch((e) => console.log(e))
        } else {
          this.$store
            .dispatch('productCategory/removeProductCategory', this.id)
            .then(() => {
              this.$store.dispatch('productCategory/fetchProductCategories')
            })
            .catch((e) => console.log(e))
        }
      }
    },
  },
  props: {
    route: {
      type: String,
      default: 'productCategory',
    },
    productCategory: {
      type: Object,
      default: () => {
        return {}
      },
    },
    experience: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style scoped>
.product-category-card {
  width: 15rem;
  color: #454655;
  margin: auto 10px;
  padding: 20px;
  border-radius: 5px;
}

.card-body {
  position: relative;
  padding: 0;
}
.card-title {
  margin-bottom: 0;
  font-size: 1.2rem;
  text-align: left !important;
  width: 150px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  position: absolute;
  top: 0%;
}

form {
  padding: 0;
  width: 100%;
}

@media screen and (max-width: 780px) {
  .product-category-card {
    width: auto;
  }
}
.product-category-card:hover {
  background: rgba(128, 128, 128, 0.315);
  color: var(--primary);
  /* margin: 20px; */
  padding: 20px;
  border-radius: 5px;
}
.product-category-card:active {
  background: #707181;
  /* margin: 20px; */
  padding: 20px;
  border-radius: 5px;
}
.right {
  position: relative;
  float: right;
}
.trashIcon {
  background: var(--primary);
  color: var(--bright);
  padding: 0.3em;
  position: absolute;
  letter-spacing: 3px;
  border: none;
  border-radius: 3.5px;
  width: 40px;
  height: 40px;
  right: 5px;
  top: -40%;
}

.icon {
  font-size: 1.3em;
  padding: 1px;
}
</style>
